import { Component, OnInit, Input, Optional, Inject, ViewChild } from '@angular/core';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgForm } from '@angular/forms';
import { CommonHelper } from '../../../../utilities/common.helper';

@Component({
	selector: 'kt-coursera-comment',
	templateUrl: './coursera-comment.component.html',
	styleUrls: ['./coursera-comment.component.scss']
})
export class CourseraCommentComponent implements OnInit {
	@ViewChild('form', { static: false }) form: NgForm;
	constructor(private loaderService: LoaderService,
		private dialogRef: MatDialogRef<CourseraCommentComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

	ngOnInit() {
		console.log(this.data);
		console.log(this.data.data.universityName);
	}

	public dismiss(type) {
		let payload = {
			comment: null,
			flag: false
		}
		this.dialogRef.close(payload);
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}
	public formValid(form): boolean {
		return form.valid;
	}

	public accept() {
		console.log(this.form)
		this.markFormsTouched(this.form);
		if (!this.formValid(this.form)) {

			return;
		}
		let payload = {
			comment: this.form.value.comment,
			flag: true
		}
		this.dialogRef.close(payload);
	}
}
